/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faArrowRight,
  faArrowUpRightFromSquare,
} from '@fortawesome/free-solid-svg-icons';
import CardButton from '../../../Components/CardButton/CardButton';
import SKVLogo from '../../../Images/Logos/SKV_RGB_li.png';

const gT = (t, key) => t(`page-external-authorization.skv-auth-step${key}`);

export default function SkvAuthStep({
  allowed,
  completed,
  openSkvTab,
  error,
  errorText,
  loading,
  t,
}) {
  return (
    <div className="auth-step">
      {completed ? (
        <div className="auth-step-completed-content">
          <FontAwesomeIcon
            className="auth-complete-icon"
            icon={faCircleCheck}
          />
          <p className="auth-complete-header">
            {gT(t, '.auth-complete-header')}
          </p>
        </div>
      ) : (
        <>
          <p className="auth-step-header">{gT(t, '.auth-step-header')}</p>
          <p className="auth-step-description">
            {gT(t, '.auth-step-description')}
          </p>
          <button
            type="button"
            className="auth-step-help-link"
            onClick={() =>
              window.open('/tutorials?as=skv', '_blank', 'noopener,noreferrer')
            }
          >
            <p>{gT(t, '.auth-step-help-link')}</p>
            <FontAwesomeIcon
              className="auth-step-help-link-icon"
              icon={faArrowUpRightFromSquare}
            />
          </button>
          {error && (
            <div className="auth-step-error">
              <p>{errorText ?? gT(t, '.error.auth-step-error')}</p>
            </div>
          )}
          <div className="integration-options-column">
            <CardButton
              textHeader={gT(t, '.card-btn.th')}
              textContent={
                allowed
                  ? gT(t, '.card-btn.tc.allowed')
                  : gT(t, '.card-btn.tc.not-allowed')
              }
              icon={faArrowRight}
              image={SKVLogo}
              onClick={openSkvTab}
              disabled={!allowed || loading}
              styleClass={!allowed ? 'integration-partner-button-disabled' : ''}
            />
          </div>
          {allowed && (
            <p className="auth-step-description">
              <i>{gT(t, '.auth-step-description-allowed')}</i>
            </p>
          )}
        </>
      )}
    </div>
  );
}
